import { __module as s } from "./ghl-ui.es1637.js";
(function(i, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  function o(n, r) {
    if (n == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
    return n;
  }
  i.exports = e.default;
})(s, s.exports);
var u = s.exports;
export {
  u as a
};
